import React, { useEffect, useState } from 'react';
import styles from '~/modules/payment/checkout-payments.module.scss';
import Image from 'next/image';
import {
  AffirmConfiguration,
  ProgressiveConfiguration,
  //   TODO:: IN STORE Offers - LIMITED
  //   LimitedTimeFinancingOfferViewModel_SpecialCampaignOffer,
  SynchronyConfiguration,
} from '~/gql/__generated__/types';
import { numberAsCurrencyWholeNum } from '~/utils/price';
import { IPaymentConnector } from '~/modules/payment/synchrony/payment-connector';
import {
  TYPES,
  valueOfEnum,
  PAYMENT_OPTIONS,
  lowerCase,
  WMAP_PREFIX,
} from '~/modules/payment/constants';
import {
  everydayFinancingOffersForCheckout,
  getFinancingOfferDetails,
  monthlyAmount,
} from '~/modules/payment/synchrony/utils/get-financing-offer-details';
import {
  getCampaignRemainingCost,
  getValidSpecialCampaign,
} from '~/modules/payment/synchrony/utils/financing-offer-calculation-utils';
import {
  ICampaignRemainingCost,
  IFinancingOfferCampaign,
  //   TODO:: IN STORE Offers - LIMITED
  //   IFinancingOfferFormatted,
} from '~/interfaces/synchrony/synchrony-interfaces';
import { ISalesOrderResponse } from '~/interfaces/get-sales-order';
import { wmapStore } from '~/store/wmap-store';
import { AffirmAPIConfig } from '~/interfaces/affirm/affirm';

import { fetchPromoData } from '~/utils/affirm-payment-connector';
import { RichText } from '~/utils/rich-text';

enum PaymentOptionsEnum {
  Visa = 'Visa',
  Synchrony = 'Synchrony',
  Progresive = 'Progresive',
  Affirm = 'Affirm',
  VI = 'VI',
}

const PaymentSelector = ({
  acceptContent,
  selectedPayment,
  handleChange,
  checkoutConfigs,
  affirmConfigs,
  progressiveConfigs,
  checkoutCart,
  isDisabled = false,
  isSingleLine,
}: {
  acceptContent: IPaymentConnector;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectedPayment: string;
  index: number;
  checkoutConfigs: SynchronyConfiguration;
  affirmConfigs: AffirmConfiguration;
  progressiveConfigs: ProgressiveConfiguration;
  checkoutCart: ISalesOrderResponse;
  cardType?: string;
  isDisabled?: boolean;
  isSingleLine?: boolean;
}) => {
  const { tenderType, config, connectorHtml } = acceptContent;
  const tenderTypeInEnum = valueOfEnum(PaymentOptionsEnum, tenderType);

  const isSynchrony = tenderType === TYPES.SYNCHRONY;
  const offer = getFinancingOfferDetails(
    checkoutConfigs,
    checkoutCart.balanceAmount,
  );
  const [defaultEverydayOffer] = everydayFinancingOffersForCheckout(
    checkoutConfigs,
    checkoutCart.balanceAmount,
    true,
  );

  const synchronySubHeading =
    //   TODO:: IN STORE Offers - LIMITED
    //   offer?.isLTO
    //     ? offer?.checkoutDisplay?.details?.replace(
    //         '{financedAmount}',
    //         String(offer.costPerMonth),
    //       )
    // :
    config?.subHeading;
  const progressiveSubHeading =
    progressiveConfigs?.progressive.subHeadingProgressiveLeasing;

  const campaign = offer && getValidSpecialCampaign(offer);
  const campaignRemainingCost =
    campaign &&
    getCampaignRemainingCost(campaign, offer, checkoutCart.balanceAmount);

  const monthlyPrice = monthlyAmount(
    offer?.isEverydayOffer ? defaultEverydayOffer : offer,
    checkoutCart.balanceAmount,
  );
  const [offerPrice, setOfferPrice] = useState(monthlyPrice);
  const [affirmPromo, setAffirmPromo] = useState('');

  useEffect(() => {
    const syfDetails = wmapStore.getState().syfDetails;
    if (syfDetails?.planOfferKey) {
      setOfferPrice(monthlyPrice);
    }
  }, [monthlyPrice]);
  useEffect(() => {
    if (tenderType === TYPES.AFFIRM) {
      const acceptPageContent: AffirmAPIConfig = JSON.parse(
        connectorHtml.AcceptPageContent,
      ) as AffirmAPIConfig;
      const fetchAffirmPromo = async () => {
        try {
          const data = await fetchPromoData(
            acceptPageContent.APIKey,
            affirmConfigs.affirmLeasingConfiguration.affirmPromoBannerUrl,
            Math.round(checkoutCart?.balanceAmount * 100),
          );
          setAffirmPromo(data || '');
        } catch {
          console.error('Unable to fetch Affirm promo');
        }
      };

      fetchAffirmPromo().catch((error) =>
        console.error('Error calling fetchAffirmPromo:', error),
      );
    }
  }, [
    tenderType,
    checkoutCart?.balanceAmount,
    connectorHtml.AcceptPageContent,
    affirmConfigs.affirmLeasingConfiguration,
    affirmPromo,
  ]);

  const title = getTitle(
    config?.heading,
    offerPrice,
    //   TODO:: IN STORE Offers - LIMITED
    // offer,
    isSynchrony,
    checkoutConfigs,
    isSingleLine,
  );

  if (!tenderTypeInEnum) {
    console.error('Unknown PaymentSelector ', tenderType);
    return null;
  }
  const images = PAYMENT_OPTIONS[tenderTypeInEnum]?.images || [];
  return (
    <>
      <div
        className={`${styles.radioWrapper} ${
          tenderType === TYPES.SYNCHRONY || tenderType === TYPES.AFFIRM
            ? styles.synchrony
            : styles.radioSelectWrapper
        } ${selectedPayment === tenderType ? styles.radioActive : ''}`}
      >
        <input
          id={`${WMAP_PREFIX}-${lowerCase(tenderType)}`}
          className={styles.radioButton}
          type="radio"
          name={tenderType}
          onChange={handleChange}
          value={tenderType}
          checked={selectedPayment === tenderType}
          tabIndex={0}
          disabled={isDisabled}
        />

        <label
          htmlFor={`${WMAP_PREFIX}-${lowerCase(tenderType)}`}
          className={`${styles.radioLabel} ${
            selectedPayment === tenderType
              ? styles.radioLabelActive
              : styles.radioLabelInactive
          }`}
        >
          {title}
          {/* Adyen: heading icons only when unselected; selected uses Drop-in brands under card number */}
          {(tenderType !== TYPES.ADYEN || selectedPayment !== TYPES.ADYEN) && (
            <div className={styles.paymentLogo}>
              {images?.map((icon, idx) => (
                <Image
                  width={tenderType === TYPES.SYNCHRONY ? 130 : 29}
                  height={tenderType === TYPES.SYNCHRONY ? 80 : 20}
                  key={`card-${idx}`}
                  src={icon.src}
                  title={icon.title}
                  alt={icon.altText}
                  tabIndex={0}
                />
              ))}
            </div>
          )}
        </label>
        {tenderType === TYPES.PROGRESIVE && progressiveSubHeading && (
          <span
            className={`${styles.affirmText} ${
              selectedPayment === tenderType ? styles.affirmSelected : ''
            }`}
          >
            <RichText
              className={styles.radioSubLabel}
              content={progressiveSubHeading}
            />
          </span>
        )}
        {tenderType === TYPES.AFFIRM && (
          <span
            className={`${styles.affirmText} ${
              selectedPayment === tenderType ? styles.affirmSelected : ''
            }`}
          >
            {affirmPromo && (
              <p
                className={styles.radioSubLabel}
                tabIndex={0}
                dangerouslySetInnerHTML={{ __html: affirmPromo }}
              />
            )}
          </span>
        )}

        {!isSingleLine &&
          shouldDisplaySubHeading(
            campaign,
            campaignRemainingCost,
            synchronySubHeading,
            isSynchrony,
          ) && (
            <span className={styles.radioSubLabel} tabIndex={0}>
              {synchronySubHeading}
            </span>
          )}
      </div>
    </>
  );
};

const shouldDisplaySubHeading = (
  campaign:
    | IFinancingOfferCampaign
    //   TODO:: IN STORE Offers - LIMITED
    // | LimitedTimeFinancingOfferViewModel_SpecialCampaignOffer
    | undefined,
  campaignRemainingCost: ICampaignRemainingCost | undefined,
  synchronySubHeading: string | undefined,
  isSynchrony: boolean,
): boolean => {
  return (
    !(campaign && campaignRemainingCost) &&
    synchronySubHeading !== undefined &&
    isSynchrony
  );
};

const getTitle = (
  heading: string | undefined,
  monthlyPrice: number,
  //   TODO:: IN STORE Offers - LIMITED
  //   offer: IFinancingOfferFormatted | undefined,
  isSynchrony: boolean,
  checkoutConfigs: SynchronyConfiguration,
  isSingleLine?: boolean,
): string => {
  if (!isSynchrony) {
    return heading?.replace('%', numberAsCurrencyWholeNum(monthlyPrice)) ?? '';
  }

  if (isSingleLine) {
    return TYPES.SYNCHRONY;
  }

  //   TODO:: IN STORE Offers - LIMITED
  //   if (offer?.isLTO && offer.specialCampaign?.enableCampaign) {
  //     return (
  //       checkoutConfigs?.financingConfigurations?.limitedCampaignSynchronyTitle ??
  //       ''
  //     );
  //   }

  const minThreshold =
    checkoutConfigs?.synchronyFinancingPurchaseRules
      ?.minimumMonthlyPurchaseThreshold;
  if (minThreshold && monthlyPrice < minThreshold) {
    return (
      checkoutConfigs?.synchronyFinancingPurchaseRules
        ?.synchronyFinancingAlternateLabel ?? ''
    );
  }

  return heading?.replace('%', numberAsCurrencyWholeNum(monthlyPrice)) ?? '';
};

export default PaymentSelector;
